import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    SchoolCalendarService,
    SchoolCalendarPopupService,
    SchoolCalendarComponent,
    SchoolCalendarDetailComponent,
    SchoolCalendarDialogComponent,
    SchoolCalendarPopupComponent,
    SchoolCalendarDeletePopupComponent,
    SchoolCalendarDeleteDialogComponent,
    schoolCalendarRoute,
    schoolCalendarPopupRoute,
    SchoolCalendarResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...schoolCalendarRoute,
    ...schoolCalendarPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        SchoolCalendarComponent,
        SchoolCalendarDetailComponent,
        SchoolCalendarDialogComponent,
        SchoolCalendarDeleteDialogComponent,
        SchoolCalendarPopupComponent,
        SchoolCalendarDeletePopupComponent,
    ],
    entryComponents: [
        SchoolCalendarComponent,
        SchoolCalendarDialogComponent,
        SchoolCalendarPopupComponent,
        SchoolCalendarDeleteDialogComponent,
        SchoolCalendarDeletePopupComponent,
    ],
    providers: [
        SchoolCalendarService,
        SchoolCalendarPopupService,
        SchoolCalendarResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiSchoolCalendarModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school-calendar/school-calendar.module.ts